import { parseURI as parseWSURI } from '@cian/chats-api/lib/browser/websocket/uri';

import { GuardError } from '../../shared/errors/GuardError';
import { IApplicationContext } from '../../shared/types/applicationContext';
import { EExceptionDomain } from '../../shared/types/exceptionDomains';
import { EventChannel, TSocketState } from '../../shared/types/socket';
import { WS_API_PATH } from '../constants/wsApiPath';

/**
 * Переходная функция для выноса сокетов из стейта. В идеальной архитектуре должно быть так https://www.taniarascia.com/websockets-in-redux/
 * @param context Контекст приложения, который расширяется сокетами
 */
export function attachSocketToContext(context: IApplicationContext) {
  const { config, logger } = context;

  const chatsBaseWsApi = config.getStrict<string>('chats.webSocketUrl');

  const baseWSUri = parseWSURI(chatsBaseWsApi);

  /* istanbul ignore if */
  if (!baseWSUri) {
    const error = new GuardError({
      domain: EExceptionDomain.Ws,
      message: 'Некорректный url вебсокета',
      details: {
        url: chatsBaseWsApi,
      },
    });

    logger.error(error);

    throw error;
  }

  const apiMethodPath = config.get<string>('chats.webSocketApiPath') || WS_API_PATH;

  const eventChannel = new EventChannel({
    baseWSUri,
    apiMethodPath,
  });

  const socket: TSocketState = {
    clientEvents: new Map(),
    eventChannel: eventChannel as EventChannel,
  };

  context.custom.socket = socket;
}
